import { render, staticRenderFns } from "./SuggestionsError.vue?vue&type=template&id=767dc89e&scoped=true&"
import script from "./SuggestionsError.vue?vue&type=script&lang=ts&"
export * from "./SuggestionsError.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionsError.vue?vue&type=style&index=0&id=767dc89e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767dc89e",
  null
  
)

export default component.exports